import { ComponentConfig } from "../../../../core/types";
import styles from "./styles.module.css";
import { getClassNameFactory } from "../../../../core/lib";
import { Section } from "../../components/Section";
import { quotes } from "./quotes";

const getClassName = getClassNameFactory("Image", styles);
let authtoken = localStorage.getItem('authToken')
export type ImageProps = {
  quote?: { index: number; label: string };
  title?: string;
  description?: string;
  align?: string;
  padding?: string;
  image?: {
    label?: string;
  };
  buttons?: {
    label: string;
    href: string;
    variant?: "primary" | "secondary";
    more?: { text: string }[];
  }[];
  scale?: string;
  width?: string;
  borderRadius?: number;
};

export const Image: ComponentConfig<ImageProps> = {
  
  fields: {
    align: {
      type: "radio",
      options: [
        { label: "left", value: "left" },
        { label: "center", value: "center" },
        { label: "right", value: "right" },
      ],
    },
    image: {
      type: "external",
      placeholder: "Select an image",
      showSearch: true,
      renderFooter: ({ items }) => {
        return (
          <div>
            {items.length} result{items.length === 1 ? "" : "s"}
          </div>
        );
      },
      
      fetchList: async ({ query }) => {
        // Fetch images from the API
        const response = await fetch('https://cms.gmart.in/media-listing', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authtoken}` ,
          },
          body: JSON.stringify({
            pageSize: 100,
            folderPrefix:"assets/GMart-Blogs-images"
          }),
        });
        const data = await response.json();

        // Filter results based on the search query
        const filteredContents = data?.contents.filter((url: string) => 
          url.toLowerCase().includes(query.toLowerCase())
        );

        return filteredContents.map((url: string) => ({
          title: url.split('/').pop(), // Extract the image name from the URL
          description: <img src={url} alt={url.split('/').pop()} style={{ width: '100px', height: 'auto' }} />, // Display the image
          url, // Store the URL for later use
        }));
      },
      mapRow: (item) => ({
        title: item.title,
        Image: <span>{item.description}</span>,
      }),
      mapProp: (result) => {
        return { label: result.url }; // Return the selected image URL
      },
      getItemSummary: (item) => item.label,
    },
    padding: { type: "text" },
    scale: {
      type: "select",
      options: [
        { label: "10%", value: "10%" },
        { label: "25%", value: "25%" },
        { label: "33%", value: "33%" },
        { label: "50%", value: "50%" },
        { label: "75%", value: "75%" },
        { label: "100%", value: "100%" },
      ],
    },
    width: {
      type: "text",
    },
    borderRadius: {
      type: "number",
    },
  },
  defaultProps: {
    title: "Image",
    description: "Description",
    buttons: [{ label: "Learn more", href: "#" }],
    padding: "64px",
    scale: "100%",
    align:"center",
    width: "80%",
    borderRadius: 24,
    
  },
  /**
   * The resolveData method allows us to modify component data after being
   * set by the user.
   *
   * It is called after the page data is changed, but before a component
   * is rendered. This allows us to make dynamic changes to the props
   * without storing the data in Puck.
   *
   * For example, requesting a third-party API for the latest content.
   */
  resolveData: async ({ props }, { changed }) => {
    if (!props.quote)
      return { props, readOnly: { title: false, description: false } };

    if (!changed.quote) {
      return { props };
    }

    // Simulate a delay
    await new Promise((resolve) => setTimeout(resolve, 500));

    return {
      props: {
        title: quotes[props.quote.index].author,
        description: quotes[props.quote.index].content,
        image: props.image,
      },
      readOnly: { title: true, description: true },
    };
  },
  // resolveFields: async (data, { fields }) => {
  //   if (data.props.align === "center") {
  //     return {
  //       ...fields,
  //       image: undefined,
  //     };
  //   }

  //   return fields;
  // },
  resolvePermissions: async (data, params) => {
    if (!params.changed.quote) return params.lastPermissions;

    // Simulate delay
    await new Promise((resolve) => setTimeout(resolve, 500));

    return {
      ...params.permissions,
      // Disable delete if quote 7 is selected
      delete: data.props.quote?.index !== 7,
    };
  },
  render: ({ align, title, description, buttons, padding, image, scale, width, borderRadius, puck }) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    // const [_] = useState(0);

    console.log("Image URL:", image?.label, align); // Log the image URL for debugging

    return (
      <div>
      <Section
        padding={padding}
        className={getClassName({
          left: align === "left",
          center: align === "center",
          right: align === "right",
        })}
      >
        <div className={getClassName("inner")} style={{ display: 'flex', justifyContent: align === "left" ? "flex-start" : align === "center" ? "center" : "flex-end" }}>
          {image?.label ? (
            <div
              style={{
                backgroundImage: `url('${image.label}')`,
                backgroundSize: `${scale }`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                borderRadius: borderRadius ,
                height: 756,
                width: width || "80%",
                maxWidth: "100%",
                margin: align === "right" ? "0 0 0 auto" : align === "left" ? "0 0 0 0" : "0 auto",
              }}
            />
          ) : (
            <div>
              <input type="file" accept="image/*" onChange={(e) => {/* Handle image upload */}} />
            </div>
          )}
        </div>
      </Section>
      </div>
    );
  },
};
